import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicCheckbox, BaasicButton, ApplicationEmptyState, BaasicDropdown } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { FacilityMissingDocsEdit } from "application/facility-missing-docs/components";

function FacilityMissingDocsPreviewTemplate({ facilityMissingDocsPreviewViewStore, t }) {
    const {
        loaderStore,
        item,
        facilityStore,
        facilityOrderTemplateStores,
        documentationRequestCreate,
        showOnlyPastTemplates,
        setShowOnlyPastTemplates
    } = facilityMissingDocsPreviewViewStore;

    const storesToRender = facilityOrderTemplateStores && facilityOrderTemplateStores.length > 0
        ? showOnlyPastTemplates
            ? facilityOrderTemplateStores.filter(x => !x.isCurrent)
            : facilityOrderTemplateStores
        : [];

    return (
        <PreviewLayout className="container container--new-flow" store={facilityMissingDocsPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
            {item &&
                <React.Fragment>
                    <div className='content__header u-mar--bottom--xlrg u-position--rel u-flex--default is-nested'>
                        <div className=' u-flex--primary u-flex--default u-flex--grow--1'>
                            <i className="u-icon u-icon--lrg u-icon--new-facility u-icon--new-facility--primary u-mar--right--sml" />
                            <div className="dropdown--header">
                                <BaasicDropdown 
                                    store={facilityStore}
                                    placeholder={t('FACILITY_MISSING_DOCS.SEARCH.SEARCH_FACILITY_PLACEHOLDER')}
                                />
                            </div>
                        </div>
                        <div className='u-flex--default u-mar--left--auto'>
                            <div className="u-mar--right--sml">
                                <BasicCheckbox className="input--check contrast-fix" checked={showOnlyPastTemplates} onChange={() => setShowOnlyPastTemplates()} id='showOnlyPastTemplates' />
                                <label>Show only past templates</label>
                            </div>
                            <BaasicButton className="btn btn--base btn--sml btn--primary" icon="u-icon u-icon--med u-icon--envelope" label="Doc Request Email" onClick={() => documentationRequestCreate()} />
                        </div>
                    </div>
                    {
                        storesToRender.map(store => (
                            <FacilityMissingDocsEdit
                                key={store.item.id}
                                facilityMissingDocsEditViewStore={store}
                            />
                        ))
                    }
                </React.Fragment>
            }
        </PreviewLayout >
    )
}

FacilityMissingDocsPreviewTemplate.propTypes = {
    facilityMissingDocsPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(FacilityMissingDocsPreviewTemplate);